
import "../../App.css"
import { Card, Form, Col, Row, Button } from 'react-bootstrap';
import signupimg from "../../asset/images/portal/signup-1.png"
import * as React from 'react';
import { useState } from 'react';
import UserService from "../../service/UserService";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import Login from "../Login/page";
function SignUp({ onSwitchPage }) {
    const navigate = useNavigate();
    const instituteId = localStorage.getItem("instituteId");

    //  const instituteId = typeof window !== "undefined" ? localStorage.getItem("instituteId") : null;
    console.log("instituteId=", instituteId);
    const [formData, setFormData] = useState({
        email: '',
        mobile: '',
        password: '',
        instituteId: instituteId ? parseInt(instituteId) : null  // pass instituteId here
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');

            const payload = {
                ...formData
            };
            console.log("payload=", payload)
            await UserService.register(payload);
            // await UserService.register(formData);
            setFormData({
                email: '',
                mobile: '',
                password: ''
            });
            alert('User registered successfully');
        } catch (error) {
            console.error('Error registering user:', error);
            alert('An error occurred while registering user');
        }
    };
    return (
        <>
            <div style={{
                display: "grid",
                placeContent: "center"
            }}>
                <Card className='mt-2'>
                    <Card.Body className='display_center'>
                        <div className='text_c' style={{ marginTop: "-20px" }}>
                            <Card.Img variant="top" src={signupimg} className='loginimg' />
                            <p >Please enter your user information.</p>
                        </div>
                        <Form >
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label >
                                    Email
                                </Form.Label>
                                <Col>
                                    <Form.Control type="text" name="email" placeholder="email@example.com" value={formData.email} onChange={handleInputChange} required />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2">
                                <Form.Label >
                                    Mobile
                                </Form.Label>
                                <Col>
                                    <Form.Control type="text" name="mobile" placeholder="mobile no" value={formData.mobile} onChange={handleInputChange} required />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2" >
                                <Form.Label >
                                    Password
                                </Form.Label>
                                <Col>
                                    <Form.Control type={showPassword ? "text" : "password"} name="password" placeholder="Password" value={formData.password} onChange={handleInputChange} required />
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            zIndex: 10,
                                        }}
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} />}
                                    </span>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-2" >
                                <Form.Label >
                                    Confirm Password
                                </Form.Label>
                                <Col>
                                    <Form.Control type={showCPassword ? "text" : "password"} name="confirmpassword" placeholder="Password" />
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            zIndex: 10,
                                        }}
                                        onClick={() => setShowCPassword(!showCPassword)}
                                    >
                                        {showCPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} />}
                                    </span>
                                </Col>
                            </Form.Group>

                            <div style={{ marginTop: "15px" }}>
                                <Button variant="contained" className="button " onClick={handleSubmit}>
                                    Create Account
                                </Button></div>

                            <div className='mt-2'>
                                <span
                                    onClick={onSwitchPage}
                                    className="fs-5 text-primary signupspan "
                                    style={{ cursor: "pointer" }}
                                >

                                    Back to Login
                                </span>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>

            </div>
        </>
    );
}

export default SignUp;